import * as THREE from "three";
import { LineMaterial } from "three/addons/lines/LineMaterial";

class MaterialManager {
    constructor( config ) {
        this.config = config;
        this.materials = {
            node: new THREE.PointsMaterial({ color: 'black', size: 6 }),
            member: new LineMaterial({ color: 'black', linewidth: 0.025, worldUnits: true }),
            support: new THREE.MeshBasicMaterial( { color: config.settings.supportsColor, transparent: true, opacity: 0.6 } ),
            load: {
                line: new THREE.LineBasicMaterial( { color: config.settings.forcesColor, toneMapped: false } ),
                mesh: new THREE.MeshBasicMaterial( { color: config.settings.forcesColor, toneMapped: false, transparent: true, opacity: 0.2 } ),
                forceMesh: new THREE.MeshBasicMaterial( { color: config.settings.forcesColor, toneMapped: false } )
            },
            reaction: {
                line: new THREE.LineBasicMaterial( { color: config.settings.reactionsColor, toneMapped: false } ),
                mesh: new THREE.MeshBasicMaterial( { color: config.settings.reactionsColor, toneMapped: false } )
            },
            axialForce: {
                line: new THREE.LineBasicMaterial( { color: config.settings.axialForcesColor, toneMapped: false } ),
                mesh: new THREE.MeshBasicMaterial( { color: config.settings.axialForcesColor, toneMapped: false, transparent: true, opacity: 0.2 } )
            },
            shearForce: {
                line: new THREE.LineBasicMaterial( { color: config.settings.shearForcesColor, toneMapped: false } ),
                mesh: new THREE.MeshBasicMaterial( { color: config.settings.shearForcesColor, toneMapped: false, transparent: true, opacity: 0.2 } ),
                limitLine: new THREE.LineDashedMaterial( { color: config.settings.shearForcesColor, toneMapped: false, dashSize: 0.1, gapSize: 0.07 } ),
                limitMesh: null,
            },
            bendingMoment: {
                line: new THREE.LineBasicMaterial( { color: config.settings.bendingMomentsColor, toneMapped: false } ),
                mesh: new THREE.MeshBasicMaterial( { color: config.settings.bendingMomentsColor, toneMapped: false, transparent: true, opacity: 0.2 } ),
                limitLine: new THREE.LineDashedMaterial( { color: config.settings.bendingMomentsColor, toneMapped: false, dashSize: 0.1, gapSize: 0.07 } ),
                limitMesh: null
            },
            deformation: {
              line: new THREE.LineBasicMaterial( { color: config.settings.deformationsColor, linewidth: 2 } ),
              limitLine: new THREE.LineDashedMaterial( { color: config.settings.deformationsColor, dashSize: 0.2, gapSize: 0.1 } )
            },
            dims: {
                line: new THREE.LineBasicMaterial( { color: 'black', toneMapped: false } ),
                mesh: new THREE.MeshBasicMaterial( { color: 'black', toneMapped: false } )
            },
        };
    }

    updateMaterials() {
        this.materials.support.color.set(this.config.settings.supportsColor);

        this.materials.load.line.color.set(this.config.settings.forcesColor);
        this.materials.load.mesh.color.set(this.config.settings.forcesColor);

        this.materials.reaction.line.color.set(this.config.settings.reactionsColor);
        this.materials.reaction.mesh.color.set(this.config.settings.reactionsColor);

        this.materials.axialForce.line.color.set(this.config.settings.axialForcesColor);
        this.materials.axialForce.mesh.color.set(this.config.settings.axialForcesColor);

        this.materials.shearForce.line.color.set(this.config.settings.shearForcesColor);
        this.materials.shearForce.mesh.color.set(this.config.settings.shearForcesColor);

        this.materials.bendingMoment.line.color.set(this.config.settings.bendingMomentsColor);
        this.materials.bendingMoment.mesh.color.set(this.config.settings.bendingMomentsColor);

        this.materials.deformation.color.set(this.config.settings.bendingMomentsColor);
    }

}

export { MaterialManager };